(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".flash-spinner svg{animation:2s linear infinite flash-spinner-animation-svg}.flash-spinner svg circle{animation:1.4s ease-in-out infinite both flash-spinner-animation-circle;transform-origin:50% 50%}@keyframes flash-spinner-animation-svg{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes flash-spinner-animation-circle{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}to{stroke-dashoffset:280;transform:rotate(360deg)}}")),document.head.appendChild(e)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
import { jsx } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import "../../../../_commonjsHelpers-0c53d963.js";
function FlashSpinner(props) {
  const { className, size = "1rem", svgProps } = props;
  return /* @__PURE__ */ jsx("span", { className: classNames(COMMON_CLASSNAME, "flash-spinner d-inline-flex", className), role: "progressbar", children: /* @__PURE__ */ jsx(
    "svg",
    {
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg",
      height: size,
      width: size,
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeDasharray: "283",
      strokeDashoffset: "280",
      strokeWidth: "10px",
      ...svgProps,
      children: /* @__PURE__ */ jsx("circle", { cx: "50", cy: "50", r: "45", fill: "transparent" })
    }
  ) });
}
export {
  FlashSpinner as default
};
//# sourceMappingURL=FlashSpinner.js.map
